<template>
  <div v-if="watermarkText" class="user-watermark" :style="watermarkStyle" />
</template>

<script>
export default {
  name: 'UserWatermark',
  computed: {
    watermarkText() {
      const userState = this.$store.state.user || {}
      return userState.name || userState.username || ''
    },
    watermarkStyle() {
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="320" height="220" viewBox="0 0 320 220">
          <g transform="rotate(-24 160 110)">
            <text
              x="50%"
              y="50%"
              dominant-baseline="middle"
              text-anchor="middle"
              fill="rgba(0, 0, 0, 0.08)"
              font-size="24"
              font-family="Arial, PingFang SC, Microsoft YaHei, sans-serif"
            >${this.escapeXml(this.watermarkText)}</text>
          </g>
        </svg>
      `.trim()

      return {
        backgroundImage: `url("data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}")`
      }
    }
  },
  methods: {
    escapeXml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;')
    }
  }
}
</script>

<style lang="scss" scoped>
.user-watermark {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 2;
  background-repeat: repeat;
  background-position: 0 0;
}
</style>
